export default __webpack_public_path__ + "static/086-7dcbccea5c1f10d43ec6527cc6d7b0b2.jpg";